/* eslint-disable no-shadow */
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import AddPaymentPage from './AddPaymentPage';
import useVenueState from './useVenueState';
import IframeHostContext from '../../contexts/iframeHost';
import { setNonce, setPaymentId } from '../../../../../ui-kitchen/src/reducers/bookingSlice';
import { getResyConfigThunk } from '../../../../../ui-kitchen/src/reducers/resyConfigSlice';
import { selectIsAuthenticated } from '../../../../../ui-kitchen/src/reducers/authTokenSlice';

const AddPaymentController = (props) => {
  const {
    Analytics,
    AutomationMode,
    backPath,
    bookingState,
    isAuthenticated,
    matchMedia,
    setNonce,
    setPaymentId,
    stripePublishableKey,
    venueId,
  } = props;

  const iframeHost = useContext(IframeHostContext);
  const venueState = useVenueState(venueId);
  const navigate = useNavigate();

  const bookingThunks = {
    setNonce,
    setPaymentId,
  };
  const viewPortHeight = iframeHost.getDimensions().innerHeight;
  const { grecaptcha } = window;

  if (!isAuthenticated) {
    navigate(`/venues/${venueId}`);
  }

  const sourceId = bookingState?.sourceId;

  return (
    <AddPaymentPage
      Analytics={Analytics}
      AutomationMode={AutomationMode}
      backPath={backPath}
      bookingState={bookingState}
      bookingThunks={bookingThunks}
      grecaptcha={grecaptcha}
      matchMedia={matchMedia}
      navigate={navigate}
      sourceId={sourceId}
      stripePublishableKey={stripePublishableKey}
      venueInfo={venueState}
      viewPortHeight={viewPortHeight}
    />
  );
};

AddPaymentController.propTypes = {
  Analytics: PropTypes.shape({}).isRequired,
  AutomationMode: PropTypes.bool.isRequired,
  backPath: PropTypes.string.isRequired,
  bookingState: PropTypes.shape({
    sourceId: PropTypes.string,
  }).isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  matchMedia: PropTypes.shape({}).isRequired,
  setNonce: PropTypes.func.isRequired,
  setPaymentId: PropTypes.func.isRequired,
  stripePublishableKey: PropTypes.string.isRequired,
  venueId: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => {
  const {
    booking, matchMedia, resyConfig, resyRouter,
  } = state;
  const { venueId } = booking;
  const { config } = resyConfig;
  const { backPath } = resyRouter;
  return {
    backPath,
    bookingState: booking,
    isAuthenticated: selectIsAuthenticated(state),
    matchMedia,
    stripePublishableKey: config?.stripe_publishable_key,
    venueId,
  };
};

const mapDispatchToProps = {
  getResyConfigThunk,
  setNonce,
  setPaymentId,
};

export { AddPaymentController as ComponentUnderTest, mapStateToProps };
export default connect(mapStateToProps, mapDispatchToProps)(AddPaymentController);
